import React from 'react';
import Routes from './Routes.js';
import { Provider } from 'react-redux';
import { store } from './store/store';
import 'bootstrap/dist/css/bootstrap.min.css';
import './style.css';
import Helmet from "react-helmet";
import { createMuiTheme } from '@material-ui/core/styles';
import { ThemeProvider } from '@material-ui/styles';
import './style.css';

import {Loading, Alert, Confirm, Notify} from './view/components';

const theme = createMuiTheme({
  typography: {
    fontFamily: [
      'Teko'
    ].join(','),
  }
});

document.title = "Nozes Trump";

const App = () => {
  return (
    <ThemeProvider theme={theme}>
      <Provider store={store}>
        <Helmet>
          <link
            rel="apple-touch-icon"
            sizes="180x180"
            href="/apple-touch-icon.png"
          />
          <link
            rel="icon"
            type="image/png"
            sizes="32x32"
            href="/favicon-32x32.png"
          />
          <link
            rel="icon"
            type="image/png"
            sizes="16x16"
            href="/favicon-16x16.png"
          />
          <link rel="manifest" href="/site.webmanifest" />
          <link rel="mask-icon" href="/safari-pinned-tab.svg" color="#5bbad5" />
          <meta name="msapplication-TileColor" content="#da532c" />
          <meta name="theme-color" content="#ffffff" />
        </Helmet>
        <Loading/>
        <Alert/>
        <Confirm/>
        <Notify/>
        <Routes />
      </Provider>
    </ThemeProvider>
  )
};

export default App;
